import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDiePost({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z" fill="#FC0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.235 14.048l.214-1.008H4.214L4 14.048h12.235z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.338 11.273h-.455l-.453 2.103h.456l.452-2.103zM8.933 11.273H7.66l-.45 2.103h1.287l.082-.381h-.831l.112-.524h.721l.083-.378h-.721l.094-.439h.814l.082-.381zM5.492 11.273c.092-.001.183.004.275.014.542.08.757.526.642 1.137-.085.438-.373.868-.967.942a1.735 1.735 0 01-.216.01h-.757l.449-2.103h.574zm-.078 1.706c.329-.065.478-.368.532-.617.07-.33.009-.632-.29-.687a1.076 1.076 0 00-.164-.011h-.195l-.283 1.329h.216c.062 0 .123-.005.184-.014zM16.492 11.273h-1.595l-.084.39h.57l-.367 1.713h.455l.368-1.713h.569l.084-.39zM11.225 12.325c.117-.58.393-1.074 1.123-1.074.664 0 .906.495.79 1.074-.115.58-.392 1.075-1.122 1.075-.664 0-.908-.495-.791-1.075zm.839.7c.38 0 .523-.354.597-.693l-.002-.005c.077-.344.037-.687-.343-.687s-.52.347-.597.692c-.077.345-.036.693.345.693zM13.37 11.892c0 .249.153.37.297.481l.24.178a.823.823 0 01.128.108.17.17 0 01.056.122.18.18 0 01-.088.157.659.659 0 01-.336.063 1.606 1.606 0 01-.452-.082l-.134.39c.2.058.408.086.616.083.182.007.363-.024.532-.09a.558.558 0 00.373-.529.476.476 0 00-.108-.308 1.279 1.279 0 00-.224-.206l-.216-.164c-.108-.082-.192-.144-.192-.24 0-.1.079-.18.178-.184.08-.007.162-.01.243-.008h.345l.085-.39h-.384a3.567 3.567 0 00-.379.014.61.61 0 00-.574.605M10.394 11.273c.069 0 .138.004.206.014.394.065.591.356.519.75a.836.836 0 01-.582.658 1.07 1.07 0 01-.316.04h-.263l-.138.641h-.452l.453-2.103h.573zm-.025 1.064a.38.38 0 00.3-.324c.034-.19-.037-.3-.15-.33a.421.421 0 00-.133-.018h-.198l-.147.686h.184a.827.827 0 00.144-.014z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.623 11.271l.27-1.271h-1.704s-.354 1.658-.357 1.665h.423l.273-1.271h.864l-.279 1.27h1.282l-.17.796h-1.279l-.255 1.189h-.966l-.076.399h1.389l.256-1.19h1.27l.34-1.585-1.281-.002z"
        fill="red"
      />
    </svg>
  )
}

export default SvgDiePost
